import { Tool } from './tool.js';
import * as glMatrix from '../../../../node_modules/gl-matrix/esm';
import { StampStroke } from '../../scene/stroke/stamp.js';
export class StampTool extends Tool {
    _size: number;
    _hardness: number;
    _stamp_position: glMatrix.vec2 | null;
    _initial_position: glMatrix.vec2 | null;
    _mouse_position: glMatrix.vec2 | null;
    edit: boolean;
    stroke: StampStroke;

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'stamp', 'Tampon');
        var self = this;
        try {
            self._size = JSON.parse(window.localStorage.getItem('PSStampTool_size') || '');
            if (isNaN(self._size) || self._size === null) {
                self._size = 200;
            }
        } catch (e) {
            self._size = 200;
        }
        try {
            self._hardness = JSON.parse(window.localStorage.getItem('PSStampTool_hardness') || '');
            if (isNaN(self._hardness) || self._hardness === null) {
                self._hardness = 0.0;
            }
        } catch (e) {
            self._hardness = 0.0;
        }
        self._stamp_position = null;
        self._initial_position = null;
        self._mouse_position = null;
        self.edit = false;
        self.stroke = new StampStroke(gl, width, height);
    }

    get size() {
        return this._size;
    }

    set size(value) {
        try {
            window.localStorage.setItem('PSStampTool_size', value.toString());
        } catch (e) {
        }
        this._size = value;
    }

    get hardness() {
        return this._hardness;
    }

    set hardness(value) {
        try {
            window.localStorage.setItem('PSStampTool_hardness', value.toString());
        } catch (e) {
        }
        this._hardness = value;
    }

    touch() {
        super.touch();
        this.stroke.reset();
    }

    destroy() {
        super.destroy();
        this.stroke.destroy();
    }

    static copy(value) {
        var result = new StampTool(value._gl, value._width, value._height);
        result.size = value.size;
        result.hardness = value.hardness;
        result.init(value._stamp_position);
        if (value._initial_position) {
            result._initial_position = glMatrix.vec2.clone(value._initial_position);
        }
        result.edit = value.edit;
        return result;
    }

    init(position) {
        var self = this;
        self._initial_position = null;
        if (position) {
            self._stamp_position = glMatrix.vec2.clone(position);
            self.stroke.setStampPoint(glMatrix.vec2.clone(position));
        }
    }

    get stampPosition() {
        return this._stamp_position;
    }

    set mousePosition(value) {
        var self = this;
        self._mouse_position = value;
        if (self._initial_position && self._stamp_position && self._mouse_position) {
            var offset = glMatrix.vec2.create();
            glMatrix.vec2.subtract(offset, self._mouse_position, self._initial_position);
            var new_stamp_position = glMatrix.vec2.create();
            glMatrix.vec2.add(new_stamp_position, self._stamp_position, offset);
            self._initial_position = glMatrix.vec2.clone(value);
            self._stamp_position = new_stamp_position;
            if (self.stroke.empty()) {
                self.stroke.setStampPoint(glMatrix.vec2.clone(new_stamp_position));
            }
        }
    }

    addPoint(point) {
        var self = this;
        self.stroke.addPoint(point, self.size / self._width);
        if (!self._initial_position) {
            self._initial_position = glMatrix.vec2.clone(point);
        }
        self._touch = true;
    }
}
